"use strict";
// packages/types/src/activity.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["AI"] = "AI";
    ActivityType["AUTH"] = "AUTH";
    ActivityType["USER"] = "USER";
    ActivityType["ORGANISATION"] = "ORGANISATION";
    ActivityType["MEMBER"] = "MEMBER";
    ActivityType["SUBSCRIPTION"] = "SUBSCRIPTION";
    ActivityType["XERO"] = "XERO";
    ActivityType["PROJECT"] = "PROJECT";
    ActivityType["TRANSACTION"] = "TRANSACTION";
    ActivityType["INVITATION"] = "INVITATION";
    ActivityType["AFFILIATE"] = "AFFILIATE";
    ActivityType["OTHER"] = "OTHER";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
